export const CONSONANT_VOWEL_PAIRS_M = [

    // ㄴ
    {
        id: 1,
        korean: "마",
        english: "ma",

    },
    {
        id: 2,
        korean: "메",
        english: "me",

    },
    {
        id: 3,
        korean: "미",
        english: "mi",

    },
    {
        id: 4,
        korean: "모",
        english: "mo",

    },
    {
        id: 5,
        korean: "므",
        english: "meu",

    },
    {
        id: 6,
        korean: "머",
        english: "meo",

    },
    {
        id: 7,
        korean: "먀",
        english: "mya",

    },
    {
        id: 8,
        korean: "매",
        english: "mae",

    },
    {
        id: 9,
        korean: "몌",
        english: "mye",

    },
    {
        id: 10,
        korean: "묘",
        english: "myo",

    },
    {
        id: 11,
        korean: "며",
        english: "myeo",

    },
    {
        id: 12,
        korean: "뮤",
        english: "myu",

        

    },

    {
        id: 13,
        korean: "만",
        english: "man", 

    },
    {
        id: 14,
        korean: "막",
        english: "mak",

        

    },
    {
        id: 15,
        korean: "밈",
        english: "mim",
        

    },
    {
        id: 16,
        korean: "맛",
        english: "mat",
        

    },
    {
        id: 17,
        korean: "맣",
        english: "mah",
        

    },
    {
        id: 18,
        korean: "멉",
        english: "meob",
        

    },
          {
        id: 19,
        korean: "믈",
        english: "meul",
        

    },
    {
        id: 20,
        korean: "맞",
        english: "mat",
        

    },
    {
        id: 21,
        korean: "맦",
        english: "maekk",
        

    },
    {
        id: 22,
        korean: "맨",
        english: "maen",
        

    },
    {
        id: 23,
        korean: "믜",
        english: "mui",
        

    },
    {
        id: 24,
        korean: "뭄",
        english: "mum",
        

    },

    {
        id: 25,
        korean: "먙",
        english: "myat",
        

    },
    {
        id: 26,
        korean: "맟",
        english: "mat",
        

    },
    {
        id: 27,
        korean: "망",
        english: "mang",
        
    },
    {
        id: 28,
        korean: "말",
        english: "mal",
        
    },
    {
        id: 29,
        korean: "멸",
        english: "myeol",
        
    },
    {
        id: 30,
        korean: "엠",
        english: "em",
        
    },
    {
        id: 31,
        korean: "멓",
        english: "meoh",
        
    },
    {
        id: 32,
        korean: "믈",
        english: "meul",
        
    },
        {
        id: 33,
        korean: "뭐",
        english: "mwo",
        
    },
        {
        id: 34,
        korean: "뮾",
        english: "myup",
        
    },
        {
        id: 35,
        korean: "말",
        english: "mal",
        
    }

    
];

